/** What a password lacks under the league's rule; empty when it is strong. Shared by the sign-up form and the API. */
export type PasswordProblem = 'length' | 'upper' | 'lower' | 'digit' | 'symbol';
export function passwordProblems(pw: string): PasswordProblem[] {
  const n = [...pw].length, out: PasswordProblem[] = [];
  if (n < 12 || n > 128) out.push('length');
  if (!/[A-ZÁÉÍÓÚÜÑ]/.test(pw)) out.push('upper');
  if (!/[a-záéíóúüñ]/.test(pw)) out.push('lower');
  if (!/\d/.test(pw)) out.push('digit');
  if (!/[^\p{L}\p{N}]/u.test(pw)) out.push('symbol');
  return out;
}

/** Emails are compared trimmed and lower-cased. */
export const normEmail = (e: string): string => e.trim().toLowerCase();
export const isEmail = (e: string): boolean => e.length <= 254 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);
